import React from 'react'

export type LangIconProps = {
    size: string,
    style: string
}

const ReoIcon = ({size, style }: LangIconProps) => {

    const s = Number(size) * 4 + 'px';

    return (
        <svg version="1.1" fill='currentColor' viewBox="0 0 100 100" style={{height: s, width: s}} className={`${style} cursor-pointer transition-slow block`} >
            <path d="M97.35638,23.55313v30.58472H29.52332c0.54028,0,1.06378-0.06769,1.5686-0.18427  c5.62134-0.96283,9.90363-5.84692,9.90363-11.74292c0-6.58716-5.33997-11.92712-11.92719-11.92712H2.64362v-6.73041H97.35638z   M19.22748,54.40518c0-5.30212,4.29828-9.6004,9.60046-9.6004l0.00305,0.04144c0.19397-0.0246,0.39032-0.04144,0.591-0.04144  c2.57727,0,4.6665,2.08923,4.6665,4.6665c0,2.45599-1.9035,4.44696-4.31238,4.6308c0.44568-0.02625,0.88452-0.07465,1.3158-0.1485  c3.08362-0.7121,5.38483-3.46918,5.38483-6.76917c0-3.84027-3.11316-6.95343-6.95343-6.95343H2.64362v36.21588h94.71277V64.00565  H28.82795C23.52576,64.00565,19.22749,59.70737,19.22748,54.40518z M29.77613,54.10208  c-0.23547,0.01385-0.46881,0.03577-0.70776,0.03577h0.45496l-0.00037-0.00513  C29.60975,54.13089,29.69056,54.10861,29.77613,54.10208z M29.52296,54.13272l0.00037,0.00513  c0.54028,0,1.06378-0.06769,1.5686-0.18427c-0.43127,0.07385-0.87012,0.12225-1.3158,0.1485  C29.69056,54.10861,29.60975,54.13089,29.52296,54.13272z"/>
        </svg>
    )
}

export default ReoIcon
